import components_hash_proxy from './components'
import { TEXT_FIELD } from './type_name'
import './style/card.less'
import {
    VCard,
    VCardTitle,
    VCardSubtitle,
    VDivider,
    VCardText,
    VRow
  } from 'vuetify/lib'
import { VRippleCol } from './components_from_custumer'
export default {
    name: 'v-table-card',
    props: {
        fields: {
            type:Array,
            default: () => []
        },
        value: {
            type: Object,
        },
        outlined: {
            type: Boolean,
            default: true
        },
        card_props: {
            type: Object,
        },
        elevation: {
            type: [Number, String]
        },
        titleTextRender: {
            type: Function
        },
        title: {
            type: [Number, String]
        },
        showSubTitle: {
            type: Boolean
        },
        subTitle: {
            type: [Number, String, Function]
        },
        md: {
            type: [Number, String]
        },
    },
    data() {
        return {
            my_value: this.value || {},
        }
    },
    watch: {
        value(new_val) {
            this.my_value = new_val
        },
        my_value(new_val) {
            this.$emit('input', new_val)
        }
    },
    methods: {
      // card的title部分
      cardTitle(h) {
        const slot = this.$scopedSlots.card_title
        let title = null
        if (slot) {
            title = slot({
                fields:this.fields,
                value: this.my_value
             })
        } else if (this.title instanceof Function) {
            title = this.title(this.value)
        } else {
            title = this.title
        }
        return h(VCardTitle, {
            props: {

            }
        }, title)
      },
      // card sub title
      cardSubTitle(h) {
        const slot = this.$scopedSlots.card_subtitle
        let title = '-'
        if (slot) {
            title = slot({
                fields:this.fields,
                value: this.my_value
             })
        } else {
            if (this.subTitle instanceof Function) {
                title = this.subTitle(this.value)
            } else {
                title = this.subTitle
            }
        }
        return h(VCardSubtitle, {
            props: {

            }
        }, title)
      },
      // 列表
      list(h) {
        const fields = this.fields
        const list = []
        fields.forEach(field => {
            const slot = this.$scopedSlots[field.key]
            if (slot) {
                list.push(slot({field, value: this.value}))
            } else {
                list.push(this.componentItem(h, field))
            }
        });
        return list
      },
      componentItem(h, field) {
        const { type, md:_md, cols:_col } = field
        let child = null
        const md = _md || this.md || 12
        const cols = _col || this.cols || 12
        if (!type) {
            child = h(components_hash_proxy[TEXT_FIELD], {
                props: {
                    value: this.value,
                    field
                }
            })
        } else {
            child = h(components_hash_proxy[type], {
                props: {
                    value: this.value,
                    field
                }
            })
        }
        return h(VRippleCol, {
            attrs: {
                md
            },
            props: {
              cols
            },
        }, [child])
      }
    },

    render(h) {
        const showSubTitle = this.showSubTitle
        const showTitle = this.showTitle
        const footer = this.$scopedSlots.footer
        const child_arr = []
        const slot = this.$scopedSlots.card_title
        if (this.title !== undefined || slot || showTitle) {
            child_arr.push(this.cardTitle(h))
        }
        if (this.subTitle !== undefined || showSubTitle) {
            child_arr.push(this.cardSubTitle(h))
        }
        if (child_arr.length) {
            child_arr.push(h(VDivider))
        }
        // VCardText
        const vCardText = h(VCardText, {}, [
            h(VRow, {}, this.list(h))
        ])
        child_arr.push(vCardText)
        if (footer) {
            child_arr.push(footer({
                value: this.value
            }))
        }
        return h(VCard, {
            class: ['v-table-card'],
            props: {
                elevation: this.elevation,
                outlined:this.outlined
            }
        }, child_arr)
    }
}